// Crisp — contexte bateau sur les pages produit
// Pousse le nom et l'URL du bateau dans la session Crisp
// afin que l'opérateur sache de quel bateau il s'agit dans l'inbox.
(function () {
  var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
  if (!meta || !meta.product) return; // pas une page produit, on sort

  // ShopifyAnalytics.meta.product.title peut être absent — fallback h1
  var title = (meta.product.title)
    || (document.querySelector('h1') && document.querySelector('h1').textContent.trim())
    || '';

  window.$crisp = window.$crisp || [];
  $crisp.push(['set', 'session:data', [[
    ['bateau', title],
    ['url_bateau', window.location.href],
    ['id_produit', String(meta.product.id)]
  ]]]);
})();
